module.exports = __webpack_public_path__ + "img/hero-image.6d7914fc.png";